import useCheckingBillingInformation from 'hooks/user/useCheckingBillingInformation';
import React, { useMemo } from 'react';
import getUser from 'redux/selector/getUser';

const CheckingBillingInformationContext = React.createContext({
  isVerified: false,
  isInProgress: false,
  isNotHaveBilling: false,
  isRejected: false,
  noNeedUpdate: false,
  checkingBillingInformation: false,
  refreshingBillingInformation: false,
  rejectReason: '',
  refreshBillingInformation: () => {},
  draftInfo: {},
  originalInfo: {},
});

export const useCheckingBillingInformationProvider = () =>
  React.useContext(CheckingBillingInformationContext);

const CheckingBillingInformationProvider = ({ children }) => {
  const { isLogged } = getUser();

  const {
    isVerified,
    isInProgress,
    isNotHaveBilling,
    isRejected,
    noNeedUpdate,
    loading: checkingBillingInformation,
    refetching: refreshingBillingInformation,
    refetch: refreshBillingInformation,
    draftInfo,
    originalInfo,
    rejectReason,
  } = useCheckingBillingInformation({ isTrigger: !!isLogged });

  const value = useMemo(() => {
    return {
      isRejected,
      isVerified,
      isInProgress,
      isNotHaveBilling,
      checkingBillingInformation,
      refreshingBillingInformation,
      refreshBillingInformation,
      draftInfo,
      originalInfo,
      rejectReason,
      noNeedUpdate,
    };
  }, [
    isRejected,
    isVerified,
    isInProgress,
    isNotHaveBilling,
    checkingBillingInformation,
    refreshBillingInformation,
    refreshingBillingInformation,
    draftInfo,
    originalInfo,
    rejectReason,
    noNeedUpdate,
  ]);

  return (
    <CheckingBillingInformationContext.Provider value={value}>
      {children}
    </CheckingBillingInformationContext.Provider>
  );
};

export default CheckingBillingInformationProvider;
